// Set by _Layout.cshtml from Round.MaxInitiative, so the client and the server agree on what a long rest is.
declare const MaxInitiative: number;

// Set by _Layout.cshtml from Monster.MaxEnemies.
declare const MaxEnemies: number;
